
import { AspectRatio } from "@/components/ui/aspect-ratio";

interface FeatureScreenshotProps {
  title: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
  reverse?: boolean;
}

export function FeatureScreenshotSection({
  title,
  description,
  imageSrc,
  imageAlt,
  reverse = false
}: FeatureScreenshotProps) {
  return (
    <section className="py-16 bg-white">
      <div className="container max-w-6xl">
        <div className={`grid md:grid-cols-2 gap-8 items-center ${reverse ? 'md:grid-flow-dense' : ''}`}>
          <div className={reverse ? 'md:col-start-2' : ''}>
            <h2 className="text-2xl md:text-3xl font-bold mb-4">{title}</h2>
            <p className="text-muted-foreground text-lg">{description}</p>
          </div>
          
          <div className={`rounded-lg shadow-md overflow-hidden border ${reverse ? 'md:col-start-1' : ''}`}>
            <AspectRatio ratio={16 / 9} className="bg-muted">
              <img 
                src={imageSrc} 
                alt={imageAlt}
                className="w-full h-full object-cover"
              />
            </AspectRatio>
          </div>
        </div>
      </div>
    </section>
  );
}
